<script>
import { Doughnut } from 'vue-chartjs';

export default {
	extends: Doughnut,
	props: {
		chartData: {
			type: Array,
			default: () => {}
		},
		labels: {
			type: Array,
			default: () => {}
		},
		colors: {
			type: Array,
			default: () => {}
		},
		responsive: {
			type: Boolean,
			default: true
		}
	},
	data: () => ({
		data: {
			options: {
				cutoutPercentage: 40,
				responsive: true
			},
			chartData: {
				datasets: [
					{
						hoverBorderWidth: 4,
						borderWidth: 0
					}
				]
			}
		}
	}),
	watch: {
		chartData: function() {
			this.data.chartData.datasets[0].data = this.chartData;
			this.$data._chart.update();
		},
		labels: function() {
			this.data.chartData.labels = this.labels;
			this.data.chartData.datasets[0].backgroundColor = this.colors;
			this.data.chartData.datasets[0].hoverBackgroundColor = this.colors;
			this.data.chartData.datasets[0].hoverBorderColor = this.colors;
			this.renderChart(this.data.chartData, this.data.options);
		}
	},
	mounted() {
		this.data.chartData.datasets[0].data = this.chartData;
		this.data.chartData.datasets[0].backgroundColor = this.colors;
		this.data.chartData.datasets[0].hoverBackgroundColor = this.colors;
		this.data.chartData.datasets[0].hoverBorderColor = this.colors;
		this.data.options.responsive = this.responsive;
		this.data.chartData.labels = this.labels;
		this.$nextTick(() => {
			this.renderChart(this.data.chartData, this.data.options);
		});
		// this.renderChart(this.data.chartData, this.data.options);
	}
};
</script>
